import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
import {postAPI } from '../../api/api';
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import FormHead from "../../components/headings/FromHead";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { submitCheck } from "../../utils/submitCheck";
import { Error } from "@progress/kendo-react-labels";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { convertToHTML } from "draft-convert";
import ShareResume from "../../modal/shareResume";
import Headline6 from "../../components/headings/Headline6";
import StarRating from "../../components/rating";
import { checkLevel } from "../../utils/EllowUtils";
import DocumentViewer from "../../components/documentViewer";

const userloginId = localStorage.getItem("loginId");

function Preview(props: any) {
  const [candidateData, setCandidateData] = useState<any>();
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );
  const [error, setError] = useState<string | undefined>("");
  const [profileSubmitted, setProfileSubmitted] = useState<boolean>(true);
  const [resumeShare, setResumeShare] = useState<boolean>()
  const [credentialSent, setCredentialSent] = useState<boolean>(false);
  const [viewResume, setViewResume] = useState<boolean>(false);
  
  useEffect(() => {
    setCandidateData(props.candaidateData);
    setProfileSubmitted(props.profileSubmitted);
    setCredentialSent(props.credentialSent);
  }, [props]);

  const dateConvert = (date: number) => {
    return new Date(date).toLocaleDateString('en-IN');
  };

  const summaryConvert = (item: any) => {
    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          let abd = draftToHtml(
            convertToRaw(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(item))
              ).getCurrentContent()
            )
          );
          let strippedHtml = abd.replace(/<[^>]+>/g, "");
          return strippedHtml;
        } catch (e) {
          return item;
        }
      }
    }
  };
  const createMarkup = (html: any) => {
    if (html && html !== null){
      if (html.includes('{"blocks')) {
        let oldblockconverteddata = convertFromRaw(JSON.parse(html));
        let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);
  
        html = JSON.stringify(oldblockdataconvertedhtml);
        return {
          __html: DOMPurify.sanitize(html),
        };
      }
      if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
        return {
          __html: DOMPurify.sanitize(JSON.parse(html)),
        };
      } else {
        html = "<p>" + html + "</p>";
        return {
          __html: DOMPurify.sanitize(html),
        };
      }
    }
  };
  const onSubmit = () => {
    let value = submitCheck(candidateData, false); 
    if (!value.error) {
      let data = {
        userLoginId: userloginId,
        candidateStatus: 5,
        loginId: props.loginId,
        submittedBy: "RECRUITER",
      };
      props.submitCheck(value.error, data);
    } else {
      setError(value.errorMessage);
    }
  };

  const container = React.useRef<HTMLDivElement>(null);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const exportPDFWithMethod = () => {
    let element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      margin: 40,
      fileName: `Report for ${new Date().getFullYear()}`,
    });
  };

  const exportPDFWithComponent = () => {

    let value={};
    postAPI( REACT_APP_CANDIDATE_FRELLANCER + `/uploadPreviewResumeToS3/`+props.loginId, value).then((data) => {
      fetch(data.url).then(response => {
        response.blob().then(blob => {
 //  decodeURIComponent(candidateData.firstName+'Resume'.slice(36, candidateData.resumeFileName.length)) 
            const fileURL = window.URL.createObjectURL(blob);
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = candidateData.firstName+'Resume.pdf';
            alink.click();
        })
    })
    });
  };

  const shareResume = (data: any) => {
    
  }
  const sentCredentials = () => {
   props.sentCredentails()
  }
  return (
    <>
      <div className={ viewResume ? Styles.preview_With_Resume : ''}>
      <section className={Styles.resourcesProfile}>
        <div className={Styles.profileHead}>
          <div className={Styles.sentOption}>
          {!profileSubmitted && props.showSubmit && props.loginId && (
            <>
              <Button variant="primary" size="xxsmall" onClick={onSubmit} disabled={props.disable}>
                Submit
              </Button>
            </>
          )}
              <Button
                variant="outlined"
                size="xxsmall"
                onClick={props.editClick}
              >
                Edit Profile
              </Button>

          {error && (
            <div>
              {" "}
              <Error>{error}</Error>
            </div>
          )}
          </div>
             { !profileSubmitted && (((userloginId === props.createdBy) || props.sourcedBy !== 'PROVIDER') ) && !credentialSent && <div className={Styles.sentOption}>
          <label>Sent credentials to the candidate</label>
          <Button variant="outlined" size="xxsmall" onClick={sentCredentials}>Sent</Button>
        </div>}
        </div>
    
        <PDFExport
          scale={0.6}
          ref={pdfExportComponent}
          paperSize="A4"
          margin={10}
          fileName={`${
            candidateData &&
            candidateData.firstName + " " + candidateData.lastName
          }`}
          author="ellow Talent Market Places Pvt Ltd"
        >
          <div className={Styles.profileWrapper}>
            <div className={Styles.profile}>
              <div className={Styles.phead}>
                <div className={Styles.pheadDetails}>
                  <figure>
                    {candidateData && candidateData.image ? (
                      <img src={candidateData.image} />
                    ) : (
                      candidateData &&
                      candidateData.firstName &&
                      candidateData.lastName &&
                      candidateData.firstName.charAt(0) +
                        candidateData.lastName.charAt(0)
                    )}
                  </figure>
                  <div className={Styles.details}>
                    <h2>
                      {candidateData &&
                        candidateData.firstName + " " + candidateData.lastName}
                    </h2>
                    {candidateData && candidateData.jobRoles && candidateData.jobRoles.length !== 0 ? 
                        <h3>
                        {candidateData &&
                          candidateData.jobRoles &&
                          candidateData.jobRoles[0] &&
                          candidateData.jobRoles[0].name}{" "}
                        | {candidateData && candidateData.positionName}
                      </h3>
                      : ' '
                    }
                    <p>
                    {candidateData &&
                      candidateData.address &&
                      candidateData.address.city}{" "}
                     {candidateData && candidateData.country}{candidateData && candidateData.preference && candidateData.preference.timeZone && Array.isArray(candidateData.preference.timeZone) && candidateData.preference.timeZone.map((item: any, key: number) => {
                      return (
                       ' || '+ item.slice(0,9)
                      )
                    })}
                    </p>
                  </div>
                </div>
                <div className={Styles.socialWrap}>
                  <p className={Styles.email}>
                    {candidateData && candidateData.email}
                  </p>
                  <p className={Styles.phone}>
                    +{candidateData && candidateData.phoneNumber}
                  </p>
                  <div className={Styles.social}>
                    {candidateData && candidateData.linkedIn && (

                      <a href={candidateData.linkedIn.includes('https://') ? candidateData.linkedIn : `https://${candidateData.linkedIn}`} target='_blank'>
                         <Icon icon="jam:linkedin-circle" />
                      </a>  
                    )}
                    {candidateData && candidateData.github && (
                    
                      <a href={candidateData.github.includes('https://') ? candidateData.github : `https://${candidateData.github}`} target='_blank'>
                        <Icon icon="jam:github-circle" />
                      </a>
                    )}
                    {candidateData && candidateData.stackoverflow && (
                  
                      <a href={candidateData.stackoverflow.includes('https://') ? candidateData.stackoverflow :`https://${candidateData.stackoverflow}`} target='_blank' >
                      <Icon icon="jam:stackoverflow-circle" />
                    </a>
                    )}
                  </div>
                </div>
              </div>
              <div className={Styles.pSummry}>
                {/* <p>{candidateData && summaryConvert(candidateData.summary)}</p> */}
                {candidateData && (
                  <div
                    className="preview"
                    dangerouslySetInnerHTML={
                      candidateData && createMarkup(candidateData.summary)
                    }
                  ></div>
                )}
                <FormHead>
                  {candidateData &&
                    candidateData.techStack &&
                    candidateData.techStack.length > 0 &&
                    candidateData.techStack[0] !== undefined && (
                      <strong>Core Skills</strong>
                    )}
                </FormHead>
                <div className={Styles.skillsWrap}>
                  {candidateData &&
                    candidateData.techStack &&
                    candidateData.techStack.map((item: any) => {
                      return (
                        <div className={Styles.skills}>
                          {item.skill.skillName}
                        </div>
                      );
                    })}
                </div>
                <FormHead>
                  {candidateData &&
                    candidateData.otherSkills &&
                    candidateData.otherSkills.length > 0 &&
                    candidateData.otherSkills[0] !== undefined && (
                      <strong>Additional Skills</strong>
                    )}
                </FormHead>
                <div className={Styles.skillsWrapAddtional}>
                  {candidateData &&
                    candidateData.otherSkills &&
                    candidateData.otherSkills.map((item: any) => {
                      return (
                        <div className={Styles.skills}>
                          {item.skillName},
                        </div>
                      );
                    })}
                </div>     
      {  ((candidateData && candidateData.ellowScreeningCertifications && candidateData.ellowScreeningCertifications.length > 0) || (candidateData && candidateData.companyRatings && candidateData.companyRatings.length > 0)) && <div>              
      <div className={Styles.subHead}>ASSESSMENT</div>
        <div className={Styles.assessmentWrap}>
              {candidateData && candidateData.assessmentLevel && <>
                <div className={Styles.assessHead}>SKILLS RATING</div>
                    <div className={Styles.formHead}>
                    <FormHead>{checkLevel(candidateData && candidateData.assessmentLevel)?.title} </FormHead>
                    </div>
                    <p>
                      {checkLevel(candidateData && candidateData.assessmentLevel)?.summary}
                    </p>
                </>}
                    <div className={Styles.ratingBlockWrap}>
      {     candidateData && candidateData.ellowScreeningCertifications &&  candidateData.ellowScreeningCertifications.map((item: any) => {
  return (
    <div className={Styles.ratingBlock}>
        <div className={Styles.ratinghead}>
        {item.skills && item.skills.name}
            <div className="ratingPreview">
            <StarRating defaultValue={item.overallRating} disabled={true} />
        </div>
            <span><em>{(item.overallRating === 0 || item.overallRating === undefined) ? '0' : item.overallRating}</em> out of 5.0</span>
        </div>
          {item && item.subSkills && item.subSkills.map((data: any) => {
            return (
              <div className={Styles.ratingList}>
                <p>{data.subSkillName ? data.subSkillName : data.subSkills.name }</p>
                <div className="ratingPreview">
                  <StarRating defaultValue={data.skillRating} disabled={true}/>
                </div>
            </div>
        )
      }) }
      </div>
      )
    }) }
    </div>
    </div>
      { candidateData && candidateData.companyRatings && <div className={Styles.assessmentWrap}>
                  <div className={Styles.assessHead}>COMPANY RATING</div>
                    <div className={Styles.ratingBlockWrap}>
                      {candidateData && candidateData.companyRatings && candidateData.companyRatings.map((item: any) => {
                        return (
                          !item.disabled &&
                          <div className={Styles.ratingBlock}>
                            <div className={Styles.formHead}>
                              <FormHead>{item.companyName}</FormHead>
                              <span>{item.designation} ({item.startDate && item.endDate && new Date(item.startDate).toDateString().slice(3) + '-'}{item.startDate && item.endDate && new Date(item.endDate).toDateString().slice(3)})</span>
                            </div>
                            <p>
                              {item.comment}
                            </p>
                            {item.overAllRating && <div className={Styles.ratinghead}>
                              Overall rating
                              <div className="ratingPreview">
                                <StarRating defaultValue={item.overAllRating} disabled={true} />
                              </div>
                              <span><em>{item.overAllRating}</em> out of 5.0</span>
                            </div>}
                            {item.subRatings.codeQuality && <div className={Styles.ratingList}>
                              <p>Code quaility</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.codeQuality} disabled={true} />
                                </div>
                              </div>
                            </div>}
                            {item.subRatings.productivity && <div className={Styles.ratingList}>
                              <p>Productivity</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.productivity} disabled={true} />
                                </div>
                              </div>
                            </div>}
                            {item.subRatings.communication && <div className={Styles.ratingList}>
                              <p>Communication</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.communication} disabled={true} />
                                </div>
                              </div>
                            </div>}

                            </div>
                       )
                     }) }
                    </div>
                </div>}
                </div>}

                {candidateData &&
                  candidateData.workHistory &&
                  candidateData.workHistory.length > 0 &&
                  candidateData.workHistory[0] !== undefined && (
                    <div className={Styles.subHead}>WORK HISTORY</div>
                  )}
                {candidateData &&
                  candidateData.workHistory &&
                  candidateData.workHistory.map((item: any) => {
                    return (
                      <div>
                        <div className={Styles.expHead}>
                          <div className={Styles.title}>
                            <h4>{item.companyName}</h4>
                            <p>{item.designation}</p>
                          </div>
                          <div className={Styles.date}>
                            {dateConvert(item.startDate)} –{" "}
                            {item.endDate
                              ? dateConvert(item.endDate)
                              : "Present"}
                          </div>
                        </div>
                        {item.description && (
                          <div
                            className="preview"
                            dangerouslySetInnerHTML={
                              item.description && createMarkup(item.description)
                            }
                          ></div>
                        )}
                        {/* <p>
                          {item.description && summaryConvert(item.description)}
                        </p> */}
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.project &&
                  candidateData.project.length > 0 &&
                  candidateData.project[0] !== undefined && (
                    <div className={Styles.subHead}>Projects</div>
                  )}
                {candidateData &&
                  candidateData.project &&
                  candidateData.project.map((item: any) => {
                    return (
                      <div>
                        <div className={Styles.expHead}>
                          <div className={Styles.title}>
                            <h4>{item.name}</h4>
                            <p>Client: {item.companyName}</p>
                          </div>
                          {/* <div className={Styles.date}>
                          {item.doneFor ? 'doneFor: ' + item.doneFor : ''}
                        </div> */}
                        </div>
                        <div className={Styles.projectSkills}>
                          {item.skills &&
                            item.skills.length !== 0 &&
                            item.skills.map((item: any, key: number) => {
                              return (
                                <div className={Styles.item}>
                                  {item.skillName}
                                </div>
                              );
                            })}{" "}
                        </div>
                        {/* <p>
                          {item.contribution &&
                            summaryConvert(item.contribution)}
                        </p> */}
                        {item.contribution && (
                          <div
                            className="preview"
                            dangerouslySetInnerHTML={
                              item.contribution &&
                              createMarkup(item.contribution)
                            }
                          ></div>
                        )}
                      </div>
                    );
                  })}

                {candidateData &&
                  candidateData.education &&
                  candidateData.education.length > 0 &&
                  candidateData.education[0] !== undefined && (
                    <div className={Styles.subHead}>Academic Details</div>
                  )}
                {candidateData &&
                  candidateData.education &&
                  candidateData.education.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.institution}</h4>
                          <p>{item.degree} </p>
                        </div>
                        <div className={Styles.date}>
                          {item.startDate
                            ? dateConvert(item.startDate) + " - "
                            : ""}
                          {item.endDate ? dateConvert(item.endDate) : "Present"}
                        </div>
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.certification &&
                  candidateData.certification.length > 0 &&
                  candidateData.certification[0] !== undefined && (
                    <div className={Styles.subHead}>
                      Awards and Certifications
                    </div>
                  )}
                {candidateData &&
                  candidateData.certification &&
                  candidateData.certification.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.name}</h4>
                          <p>{item.certifiedYear} </p>
                        </div>
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.language &&
                  candidateData.language.length > 0 &&
                  candidateData.language[0] !== undefined && (
                    <div className={Styles.subHead}>languages</div>
                  )}
                {candidateData &&
                  candidateData.language &&
                  candidateData.language.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.name}</h4>
                          <p>{item.proficiency} </p>
                        </div>
                      </div>
                    );
                  })}
                 {candidateData &&
                  candidateData.publication &&
                  candidateData.publication.length > 0 &&
                  candidateData.publication[0] !== undefined && (
                    <div className={Styles.subHead}>Publications</div>
                  )}
                 {candidateData &&
                  candidateData.publication &&
                  candidateData.publication.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.title}</h4>
                          <p>{item.link} </p>
                          </div>
                          <div className={Styles.date}>
                          {item.year}
                            </div>
                        
                      </div>
                    );
                  })}

              </div>
            </div>
          </div>
         
          
        </PDFExport>
        {resumeShare && <ShareResume onClose={() => setResumeShare(false)} clickHandler={shareResume}/>}
        <div className={Styles.shareandprint}>
          <button title="View Resume" onClick={() => setViewResume((prev) => !prev ) }>
              <Icon icon="carbon:task-view"  />
            </button>
          <button onClick={exportPDFWithComponent}>
            <Icon icon="lucide:printer" />
          </button>
        </div>
        </section>
        {viewResume && <section className={Styles.document_Viewer}>
          <DocumentViewer fileName={props.candaidateData?.resumeFileName} />
        </section>}
        </div>
    </>
  );
}

export default Preview;
